var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSegmentBuilding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M822 841C834 841 844 832 844 820C844 808 834 798 822 798H204V205C204 193 194 183 182 183C171 183 161 193 161 205V820C161 832 171 841 182 841H822ZM340 641C348 641 355 636 359 629L427 500L483 531C492 536 502 534 509 527L656 366L841 364C853 364 862 354 862 342C862 330 851 320 840 321L646 323C640 323 635 326 631 330L489 485L429 452C424 450 418 449 413 451C407 452 403 456 400 461L344 567L290 416C286 405 274 399 263 403C251 407 246 420 250 431L320 626C323 634 330 640 339 641H340Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentBuilding);
export default __webpack_public_path__ + "static/media/segment_building.eeb0feb4b968ada66b3248ed9fea1e12.svg";
export { ForwardRef as ReactComponent };